<div class="selection-container" cdkDropListGroup>
  <wlm-select-drag-list-virtual
    *ngIf="settings"
    class="select-drag-list-virtual"
    [settings]="settings"
    [itemsData]="instances"
    (selectedItemChange)="onSelectItem($event)"
  >
    <ng-template let-rowDetail #card>
      <wlm-generic-card [item]="rowDetail" [settings]="cardSettings">
        <ng-template #right>
          <div class="add-button-container">
            <button
              mat-icon-button
              color="primary"
              (click)="deleteInstance()"
              [matTooltip]="'common.remove' | translate | lowercase"
              [disableRipple]="true"
              onclick="this.blur()"
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </div>
        </ng-template>
      </wlm-generic-card>
    </ng-template>
  </wlm-select-drag-list-virtual>
</div>
